<template>
  <ul class="hotEntry">
    <li v-for="entry in entries" :key="entry.id" class="hotEntry__entry">
      <div class="hotEntry__entryImage"
           :style="backgroundImage(entry.image_url)"
      >
      </div>
      <div class="hotEntry__entryText">
        <a :href="entry.link" target="_blank" class="hotEntry__entryTitle">
          {{ entry.title.rendered }}
        </a>
        <p v-html="entry.contents" class="hotEntry__entryLead"></p>
      </div>
    </li>
  </ul>
</template>

<script>

export default {
    data: function() {
        return {
            entries: []
        };
    },
    created: function() {
        // vue側で設定してる共通ヘッダーがあるとcorsできない
        $.ajax('https://gourmetplus.jp/guide/wp-json/wp/v2/posts?_embed&tags=59&filter[orderby]=modified&order=desc').then(function(response) {
            this.entries = response;
            _.forEach(this.entries, function(entry) {
                entry.link = entry.link.replace(/^https?:\/\/[^/]+/, '');
                entry.image_url = entry._embedded['wp:featuredmedia'][0].source_url;
                entry.contents = entry.excerpt.rendered.replace(/<a .*<\/a>/g, '')
            });
        }.bind(this));
    }
};
</script>
